import Vue from 'vue';

export const init = () => {
  const translationsSv = {
    '{companies} companies on site': '{companies} företag på plats',
    '{days} Days total': '{days} Kalenderdagar',
    '{days} days': '{days} dagar',
    '{value} days late': '{value} dagar sen',
    '{value} weeks late': '{value} veckor sen',
    '{year} w.{week} {dayOfWeek} {time}': '{year} v.{week} {dayOfWeek} {time}',
    '1 Week': '1 vecka',
    '3 Weeks': '3 veckor',
    '5 to 10 hours ago': '5 - 10 timmar sedan',
    'A few hours ago': 'Några timmar sedan',
    'A minute ago': 'För en minut sedan',
    'A moment ago': 'Alldeles nyss',
    'About 45 minutes ago': 'Trekvart sedan',
    'About a day ago': 'Ungefär för en dag sedan',
    'About a quarter ago': 'En kvart sedan',
    'About an hour ago': 'Ungefär en timme sedan',
    'About an hour and a half ago': 'Ungefär en och en halv timme sedan',
    'About half an hour ago': 'En halvtimme sedan',
    'About two days ago': 'Ungefär 2 dagar sedan',
    'About two hours ago': 'Ungefär två timmar sedan',
    'Access control': 'Passagesystem',
    'Accessability ': 'Tillgänglighet',
    'Acoustic roof': 'Undertak',
    'Acoustic': 'Akustikprojektör',
    'Action In Progress': 'Åtgärd pågår',
    'Action Plan': 'Åtgärdslista',
    'Action required': 'Åtgärd krävs',
    'Activity': 'Aktivitet',
    'Add Comment': 'Lägg till kommentar',
    'Add Company': 'Lägg till företag',
    'Add controlDate': 'Lägg Kontrolldatum',
    'Add deliveryDate': 'Lägg Leveransdatum',
    'Add e-mail to contact card to add user.': 'Skriv in e-post på kontaktkortet för att kunna lägga till en användare/inloggning',
    'Add from template': 'Lägg till från mall',
    'Add new person': 'Lägg till ny person',
    'Add New': 'Lägg till',
    'Add Part': 'Lägg till etapp',
    'Add Participant': 'Lägg till Deltagare',
    'Add Stage': 'Lägg till moment',
    'Add text here…': 'Fritext…',
    'Add Workplace Introduction': 'Lägg till API',
    'add': 'lägga till',
    'Added Part Comment': 'Skrev kommentar på etapp',
    'Added Part': 'Lade till etapp',
    'Added Stage': 'Lade till moment',
    'Address': 'Adress',
    'Admin': 'Administratör',
    'Administrator': 'Administatör',
    'Alarm': 'Larm',
    'All': 'Alla',
    'Allergies/Diseases': 'Allergier/Sjukdomar',
    'All legacy files will be deleted. Are you sure you want to delete all legacy files?': 'Alla äldre filer kommer att raderas. Är du säker på att du vill ta bort alla äldre filer?',
    'Almost a day ago': 'Ungefär för en dag sedan',
    'Aluminium Doors': 'Alupartier',
    'Aluminum Doors': 'Alupartier',
    'Appliances Apartment': 'Vitvaror Lägenhet',
    'Appliances Store': 'Vitvaror Lokaler',
    'Appliances': 'Vitvaror',
    'Approval': 'Godkännande',
    'April': 'April',
    'Architect 1': 'Arkitekt 1',
    'Architect 2': 'Arkitekt 2',
    'Architect Assistant': 'Arkitekt Asisstent',
    'Architect MSA': 'Arkitekt MSA',
    'Architect': 'Arkitekt',
    'Archive Project?': 'Radera projekt?',
    'Archive Project': 'Radera projekt',
    'Archive the Project': 'Radera projektet',
    'Are you sure you want to archive the project {title}?': 'Är du säker på att du vill radera projektet {title}?',
    'Are you sure you want to delete the file of {fileName}?': 'Är du säker på att du vill ta bort filen för {fileName}?',
    'Are you sure you want to delete {count} contacts? This action cannot be undone!': 'Är du säker på att du vill ta bort {count} kontakter? Denna åtgärd kan inte ångras!',
    'Are you sure you want to save both cards? If not then press cancel and tick the one to be deleted.': 'Säkert att du vill spara båda korten? Tryck annars avbryt och bocka i den som skall raderas.',
    'Area of expertise': 'UE Link',
    'Assign worker': 'Redigera utförare av arbetsmoment',
    'Assigning user credentials to person': 'Skapar användkonto',
    'August': 'Augusti',
    'Authorities': 'Kommun',
    'Back / Abort': 'Tillbaka / Avbryt',
    'Back': 'Backa',
    'Balcony Railing Montage': 'Balkongräcke Montage',
    'Balcony railing': 'Balkongräcke',
    'Balcony Railing': 'Balkongräcke',
    'Black': 'Svart',
    'Blacksmith Frame': 'Smed stomme',
    'Blacksmith Stair railing': 'Smed trappräcken',
    'Blacksmith Stairs': 'Smed trappa',
    'Blacksmith': 'Smed',
    'Blasting Ground works': 'Sprängning Schakt',
    'Blasting': 'Sprängning',
    'Blue': 'Blå',
    'Borehole Heating': 'Borrhål Värme',
    'Brown': 'Brun',
    'Building Type': 'Typ av byggnation',
    'Business': 'Företag',
    'businessInsuranceFile': 'Företagsförsäkring',
    'Cancel': 'Avbryt',
    'Carpenter Apartments': 'Snickare Lägenhet',
    'Carpenter BMSS/LSS': 'Snickare BMSS/LSS',
    'Carpenter Cabinets': 'Snickare Snickerier',
    'Carpenter Doors': 'Snickare Dörrar',
    'Carpenter Gypsum & Steel': 'Snickare Gips & Stål',
    'Carpenter Hotel': 'Snickare Hotell',
    'Carpenter Office': 'Snickare Kontor',
    'Carpenter Pre-School': 'Snickare Förskola',
    'Carpenter Roof': 'Snickare Tak',
    'Carpenter Windows': 'Snickare Fönster',
    'Carpenter': 'Snickare',
    'Changed "{item}" to "{data}"': 'Ändrade "{item}" till "{data}"',
    'Changed Role': 'Ändrade ansvarig',
    'Chiller technician': 'Kyltekniker',
    'Choose a project to base the new one upon': 'Välj ett projekt att basera det nya på',
    'Choose area of expertise': 'Välj UE Link',
    'Choose company and person': 'Välj Företag och person',
    'Choose Company': 'Välj företag',
    'Choose or enter a building type': 'Välj eller ange byggnadstyp',
    'Choose or enter a project type': 'Välj eller anger projekttyp',
    'Choose or enter responsibility': 'Välj eller ange ansvarsområde',
    'Choose Person': 'Välj person',
    'Choose responsible manager': 'Välj ansvarig',
    'Choose Template': 'Välj mall',
    'Choose to copy the previous entry or start blank': 'Välj om du vill kopiera föregående inlägg eller börja med tomt inlägg',
    'Choose UE-Link ( Labour )': 'Välj UE-Link ( Arbetsmoment )',
    'City': 'Ort',
    'Click date below to start:': 'Klicka på datum nedan för att fylla i:',
    'Click edit and add persons and a short note on the work they did': 'Klicka på redigera och fyll i antal personer samt en kort beskrivning om arbetet dom utfört.',
    'Click here': 'Klicka här',
    'Click on the plus to edit, swipe from right to left if the UE is not present for the dayunder "Other workplace"': 'Klicka på plusset för att redigera, svep från höger till vänster ifall UE ej är närvarande för dagen',
    'Click the plus-button to edit': 'Klicka på plusset för att redigera',
    'Client 1': 'Beställare 1',
    'Client 2': 'Beställare 2',
    'Client Architectual': 'Beställare Arkitektur',
    'Client Contract': 'Beställare Avtal',
    'Client Production': 'Beställare Produktion',
    'Client Technical': 'Beställare Tekniskt',
    'Client': 'Beställare',
    'Close Preview': 'Stäng',
    'Close': 'Stäng',
    'codeOfConduct': 'Uppförandekod',
    'codeOfConduct.CHECKED': 'Godkänd',
    'codeOfConduct.UNCHECKED': 'Granskas',
    'codeOfConduct.UNKNOWN': 'Saknas',
    'codeOfConduct.filter.CHECKED': 'Uppförandekod godkänd',
    'codeOfConduct.filter.UNCHECKED': 'Uppförandekod granskas',
    'codeOfConduct.filter.UNKNOWN': 'Uppförandekod saknas',
    'Colour': 'Färg',
    'Comment below what works is ongoing, how many workers and if any errors.': 'Nedan fyller du i generellt om pågående arbeten, fördelning manskap samt ev. avvikelser.',
    'Comment': 'Kommentar',
    'Company name': 'Företagsnamn',
    'Company': 'Företag',
    'companyRegistrationFile': 'Bolagsregistrering',
    'Competence': 'Behörighet',
    'Complement the list of parts below and assign responsibilities.': 'Komplettera listan nedan och tilldela ansvariga',
    'Complete the information of all sub contactors to complete the diary': 'Fyll i status på alla UE för att komma vidare!',
    'Completion not confirmed': 'Färdigställande ej bekräftat',
    'Concrete': 'Betong',
    'Confirm': 'Bekräfta',
    'Constructor': 'Konstruktör',
    'Contact List': 'Kontaktlista',
    'Contact Person': 'Kontaktperson',
    'contractor': 'utförande entreprenör',
    'Control Comment': 'Kontrollinformation',
    'Control Date': 'Kontrolldatum',
    'Control fulfilled': 'Godkänn utförande',
    'Control Manager': 'Kontrollansvarig',
    'Control not confirmed': 'Kontroll ej bekräftad',
    'Copy the previous day': 'Kopiera föregående inlägg',
    'Copy': 'Kopiera',
    'Core drilling': 'Håltagning',
    'Country': 'Land',
    'CPR': 'HLR',
    'Crane mobile': 'Mobilkran',
    'Crane tower': 'Tornkran',
    'Crane': 'Kran',
    'Create a new registration link': 'Skapa en ny registreringslänk',
    'Create account': 'Skapa konto',
    'Create Activity': 'Skapa Aktivitet',
    'Create Project': 'Skapa Projekt',
    'Create template from these items': 'Skapa mall med dessa punkter',
    'Created by': 'Skapad av',
    'Dags för diary': 'Dags för dagbok',
    'Data missing Click here to add contractor': 'Info saknas Klicka här för att lägga till utförande entreprenör',
    'Data missing': 'Info saknas',
    'Data': 'Data',
    'December': 'December',
    'Decontamination': 'Sanering',
    'Delete account': 'Ta bort konto',
    'Delete contact': 'Ta bort kontakt',
    'Delete contacts': 'Ta bort kontakter',
    'Delete Part': 'Ta bort etapp',
    'Delete Stage': 'Ta bort moment',
    'Delete': 'Radera',
    'Delete a file?': 'Ta bort en fil?',
    'Delete legacy files': 'Ta bort äldre filer',
    'Delivery Comment': 'Leveransinformation',
    'Delivery date': 'Leveransdatum',
    'Delivery Date': 'Leveransdatum',
    'Delivery instructions': 'Leveransinstruktioner',
    'Delivery is fulfilled': 'Leveransen har godkänts',
    'Delivery not confirmed': 'Leverans ej bekräftad',
    'Delivery recipient': 'Godsmottagare',
    'Delivery size': 'Omfattning',
    'Delivery': 'Leverans',
    'Developing Company': 'Byggherre',
    'Developing Manager': 'Byggherre DRI',
    'Diary start': 'Dagbok start',
    'Diary': 'Dagbok',
    'Documents & Certificates': 'Dokument & Certifikat',
    'Do not use': 'Använd ej',
    'Does not log in actively': 'Inlogg ej aktivt',
    'Don\'t archive': 'Radera inte',
    'Done Date': 'Klart',
    'Door closer': 'Dörrautomatik',
    'Download as Excel': 'Ladda ner Exceldokument',
    'Download ID06 file': 'Ladda ner ID06 fil',
    'Download Project': 'Ladda ner Projekt',
    'Drag and drop file here': 'Dra och släpp filen här',
    'Duplicate Project': 'Skapa Kopia',
    'Duplicate Stage': 'Duplicera',
    'Duplicated Project': 'Skapade Kopia av Project',
    'Duration': 'Omfattning',
    'E-mail': 'E-post',
    'E-mail is invalid': 'E-postadressen är felaktig',
    'E-mail will not be saved because it is not in a valid format': 'E-post kommer inte att sparas eftersom det inte är i ett giltigt format',
    'Edit Inspection Templates': 'Ändra Inspektionsmallar',
    'Edit Standard Project': 'Ändra standardprojektet',
    'Edit Todo Item Templates': 'Ändra Checklistmallar',
    'Ej med i Diary': 'Ej med i dagbok',
    'Electrician Design': 'EL Design',
    'Electrician Production': 'EL Produktion',
    'Electrician': 'El',
    'Elevator inspection': 'Hiss Besiktning',
    'Elevator': 'Hiss',
    'Email address to send email to': 'Epostadress att skicka epost till',
    'Email': 'Epost',
    'Empty Project': 'Tomt Projekt',
    'en': 'English',
    'End Date': 'Slutdatum',
    'Ends': 'Slutar',
    'Energy Calculation': 'Energiberäkning',
    'Enter todays diary': 'Ange dagens utförda arbeten',
    'Environmental Plan': 'Miljöplan',
    'Estrich': 'Estrich',
    'Execution': 'Utförande',
    'Expires {expiryDate}': 'Upphör {expiryDate}',
    'Expires today': 'Förfaller idag',
    'Export': 'Exportera',
    'Facade Brick': 'Fasad Tegel',
    'Facade Puts': 'Fasad Puts',
    'Facade Sheet material': 'Fasad Skivmaterial',
    'Facade Sheet Metal': 'Fasad Plåt',
    'Facade Wood': 'Fasad Trä',
    'Facase Sheet metal': 'Fasad Plåt',
    'Failed to generate QR code': 'Det gick inte att generera QR-kod',
    'Failed to update file status': 'Det gick inte att uppdatera filstatus',
    'Failed to update code of conduct status': 'Det gick inte att uppdatera status för uppförandekoden',
    'Failed to load file preview': 'Det gick inte att läsa in förhandsgranskningen av filen',
    'Failed to merge contacts': 'Det gick inte att slå samman kontakter',
    'Failed to upload file': 'Det gick inte att ladda upp filen',
    'Failure reason list': 'Lista över orsaker till fel',
    'Failure reason list is empty': 'Listan över orsaker till fel är tom',
    'February': 'Februari',
    'File is not an image: unable to display preview': 'Filen är inte en bild: det går inte att visa förhandsgranskning',
    'File manager': 'Filhanterare',
    'File Manager': 'Filhanterare',
    'File preview': 'Filförhandsgranskning',
    'fileName.additionalFile': 'Ytterligare fil',
    'fileName.cprTrainingFile': 'HLR-träningsfil',
    'fileName.hotWorkFile': 'Hot workfil',
    'fileName.id06CardFile': 'ID06 File',
    // Legacy name for ID06 file
    'fileName.confirmationFile': 'ID06 File',
    'fileName.idFile': 'ID File',
    'fileName.safeLiftingFile': 'Säker lyftfil',
    'fileName.safetyConstructionTrainingFile': 'Säkerhet konstruktion utbildningsfil',
    'fileName.ueFile': 'UE-2021 file',
    'fileName.workInMobileWorkPlatformsFile': 'Arbeta i fil för mobila arbetsplattformar',
    'fileStatus.APPROVED': 'Godkänd',
    'fileStatus.FOR_APPROVAL': 'Granskas',
    'fileStatus.NOT_LOADED': 'Saknas',
    'fileStatus.WRONG': 'Orätt',
    'Filter': 'Filtrera',
    'Fire': 'Brand',
    'First Name': 'Förnamn',
    'Floor Carpet': 'Mattläggare',
    'Foundation': 'Grund',
    'Frame Design': 'Stomme Design',
    'Frame Finish': 'Stomme Finish',
    'Frame Montage': 'Stomme Montage',
    'Frame Production': 'Stomme Produktion',
    'Frame': 'Stomme',
    'Free text regarding site, anomalies or general notes not about contractors current works': 'Allmänt om arbetsplatsen, avvikelser eller  generellt som ej platsar i UE avstämning.',
    'Free text search': 'Fritextsök',
    'Fri': 'Fre',
    'Friday': 'Fredag',
    'fTaxCertificateFile': 'F-Skatt',
    'Fulfilled at': 'Mottagen',
    'Generate link': 'Skapa länk',
    'Generate new registration link for {project}': 'Skapa en ny registreringslänk för {project}',
    'Generate new registration link that can be used by subcontractor to enter their details': 'Skapa en ny länk som kan användas av underleverantörer för att mata in sina detaljer',
    'Generate new registration link': 'Skapa en ny länk',
    'Generating link for {project}': 'Skapar länk för {project}',
    'Geotechnics': 'Geoteknik',
    'Green': 'Grön',
    'Grey': 'Grå',
    'Go to site': 'Visa sida',
    'Ground Foundation': 'Mark Grund',
    'Ground Landscaping': 'Ground Landscaping',
    'Ground': 'Mark',
    'Guarantee Contractor': 'Garantiansvarig Byggherre',
    'Highlight This Day': 'Flagga den här dagen',
    'Hot Words': 'Heta Arbeten',
    'Import Project': 'Importera Projekt',
    'inspection-download-report.sv': 'Läs protokoll',
    'inspection-download-report.en': 'Read report',
    'inspection-stage-title.INIT': 'Förslag',
    'inspection-stage-title.PREPARE': 'Förbereder',
    'inspection-stage-title.IN_PROGRESS': 'Pågående',
    'inspection-stage-title.COMPLETE': 'Pågående',
    'inspection-stage-title.FINALIZED': 'Rundan gjord',
    'inspection-stage-title.REPORTED': 'Rapport skickad',
    'Inspections': 'Skyddsrond',
    'Inspection Construction': 'Besiktning Bygg',
    'Inspection EL': 'Besiktning EL',
    'Inspection Electricity': 'Besiktning El',
    'Inspection Elevator': 'Besiktning Hiss',
    'Inspection Facade': 'Besiktning Fasad',
    'Inspection Ground': 'Besiktning Mark',
    'Inspection Sheet metal': 'Besiktning Plåt',
    'Inspection SÖE': 'Besiktning Styr',
    'Inspection VVS': 'Besiktning VVS',
    'Insulation': 'Isolering',
    'insuranceContractEmployeesFile': 'Försäkringsavtal anställda',
    'Invalid Email': 'Ogiltig Epost',
    'Item': 'Objekt',
    'January': 'Januari',
    'July': 'Juli',
    'June': 'Juni',
    'Landscape Architect': 'Landskapsarkitekt',
    'Landscape': 'Liggande',
    'Landscaping architect': 'Landskapsarkitekt',
    'Language': 'Språk',
    'Last Login: {fuzzy} ({date})': 'Senast inloggad: {fuzzy} ({date})',
    'Last mailed on {lastMailedOn}': 'Skickades senast {lastMailedOn}',
    'Last Name': 'Efternamn',
    'Late Parts': 'Passerade åtgärdspunkter',
    'Late': 'Försenad',
    'Legacy Documents & Certificates': 'Äldre Dokument & Certifikat',
    'Less than 10 minutes ago': 'Mindre än 10 minuter sedan',
    'Less than 5 minutes ago': 'Mindre än 5 minuter sedan',
    'Less than a month ago': 'Mindre än en månad sedan',
    'Less than a week ago': 'Mindre än en vecka sedan',
    'Less than two weeks ago': 'Mindre än 2 veckor sedan',
    'Lining/Base': 'Listning',
    'Lining/Baseboard': 'Listning',
    'Link Copied': 'Länk Kopierad',
    'List Companies': 'Lista företag',
    'List of Workplace Introductions': 'Lista över arbetsplatsintroduktioner',
    'List Persons': 'Lista personer',
    'List Users': 'Lista användare',
    'Loading Companies': 'Laddar företag',
    'Loading Persons': 'Laddar personer',
    'Loading Project': 'Laddar projekt',
    'Lock Dragging': 'Lås dra och släpp',
    'Lock Project': 'Lås projekt',
    'Locked by {username}': 'Låst av {username}',
    'Locksmith': 'Låssmed',
    'Log in actively': 'Inlogg aktivt',
    'Log Out': 'Logga ut',
    'Loose wool': 'Lösull',
    'Mail': 'Maila',
    'Mail last sent {fuzzy} ({date})': 'Mail skickat {fuzzy} ({date})',
    'Mail link for project {project}': 'Maila länken för projektet {project}',
    'Mail link to {email}': 'Skicka registreringslänk till {email}',
    'Mailing to {linkMailTo}': 'Mailar till {linkMailTo}',
    'Mail link': 'Maila länk',
    'Mail new password': 'Maila lösen',
    'Mail registration link': 'Skicka registreringsmail',
    'Mail registration link to subcontrator': 'Skicka registreringsmail till underleverantören',
    'Main Business': 'Affärsområde',
    'Main Inspector': 'Huvudbesiktningsman',
    'Manage': 'Hantera',
    'Managers': 'Ledning',
    'March': 'Mars',
    'May': 'Maj',
    'Missing UE-2021 file': 'UE-2021 fil saknas',
    'Merge contacts': 'Slå ihop kontakt',
    'Merge': 'Slå ihop',
    'Mon': 'Mån',
    'Monday': 'Måndag',
    'Monitoring/Contol System': 'Styrsystem',
    'Monitoring/Control System': 'Styrsystem',
    'More than a day ago': 'Mer än en dag sedan',
    'More than a month ago': 'Mer än en månad sedan',
    'Moved Child': 'Flyttade momen/etapp',
    'Name': 'Namn',
    'Navigate': 'Navigera',
    'Nearest Manager - Name': 'Närmaste Chef - Namn',
    'Nearest Manager - Phone Number': 'Närmaste Chef - Telefonnummer',
    'Nearest Relative - Name': 'Närmaste Anhörig - Namn',
    'Nearest Relative - Phone Number': 'Närmaste Anhörig - Telefonnummer',
    'Needs carrying': 'Bärhjälp',
    'Never logged in': 'Aldrig inloggad',
    'New occupation {occupation} has been created': 'En ny roll {occupation} har blivit tillagd',
    'New Part': 'Ny etapp',
    'New Project': 'Nytt Projekt',
    'New Stage': 'Nytt moment',
    'New Template': 'Ny mall',
    'New User': 'Ny användare',
    'Next Of Kin': 'Närmast anhörig',
    'No files associated with this person': 'Inga filer associerade med denna person',
    'No match found, add new...': 'Hittar ingen, lägg till...',
    'No matching company found': 'Hittar inget företag',
    'No templates found': 'Hittar inga mallar',
    'No Work Performed this date': 'Inget arbete utfört denna dag',
    'No Work Performed': 'Inget arbete utfört',
    'No': 'Nej',
    'Not assigned, add in time plan and then return here': 'Ej tillagd, lägg till i tidplan och återgå hit sedan',
    'Not assigned,': 'Ej tillagd',
    'Notify': 'Notifiering',
    'November': 'November',
    'Occupation has been deleted': 'Rollen borttagen',
    'Occupation': 'Yrke',
    'Oct': 'Okt',
    'October': 'Oktober',
    'On the next step you will fill out details of each sub contractor.': 'I nästa steg kommer du fylla i detaljerna kring varje underentreprenör.',
    'Only my stages': 'Mina uppgifter',
    'Open All Stages': 'Expandera allt',
    'Open link': 'Ga till sida',
    'or': 'eller',
    'Orange': 'Orange',
    'Organisation': 'Organisation',
    'Original value': 'Ursprungligt värde',
    'Other comments': 'Övriga kommentarer',
    'OTHERS TO REPORT': 'ÖVRIGT ARBETSPLATS',
    'Ouch!': 'Ajdå!',
    'Outer water/Drainage': 'Yttre VA',
    'Outer Water/Drainage': 'Yttre VA',
    'OVK': 'OVK',
    'Page Layout': 'Orientering',
    'Page Size': 'Pappersstorlek',
    'Painter': 'Måleri',
    'Parquet Fishbone': 'Parkett Fiskben',
    'Parquet Industrial': 'Parquet Industrial',
    'Parquet': 'Parkett',
    'Participants': 'Deltagare',
    'Password': 'Lösenord',
    'Performing company for labour': 'Utförande företag för arbetsmomentet',
    'Person with this email already exists': 'Personen med denna epost finns redan',
    'Persons data corrupted': 'Personuppgifter är korrupta',
    'Phone to Next Of Kin': 'Telefonnummer till närmast anhörig',
    'Phone': 'Telefonnummer',
    'Photo ID-06': 'Foto ID-06',
    'Pile driving Concrete': 'Pålning Betong',
    'Pile driving Steel': 'Pålning Stål',
    'Pile driving Wood': 'Pålning Trä',
    'Pile driving': 'Pålning',
    'Piling': 'Pålning',
    'Pink': 'Rosa',
    'Please sign in the box': 'Vänligen skriv under i rutan',
    'Portrait': 'Stående',
    'Print': 'Skriv ut',
    'Priorities list': 'Prioriteringar lista',
    'Priorities list is empty': 'Prioriteringslistan är tom',
    'Prioritize your work!': 'Prioritera ditt arbete!',
    'Production Commander': 'Production Commander',
    'Production Director': 'Produktionschef',
    'Production': 'Produktion',
    'Professional Kitchen': 'Storkök',
    'Project Address': 'Projektadress',
    'Project BTA': 'Projektets BTA',
    'Project Description': 'Projektbeskrivning',
    'Project Director Assistant': 'Projektledarassistent',
    'Project Director': 'Projektledare',
    'Project End': 'Projektavslut',
    'Project Icon': 'Projektikon',
    'Project Leader': 'Projektledare',
    'Project List': 'Projektlista',
    'Project Log': 'Projekt Logg',
    'Project Management': 'Projektering',
    'Project Manager': 'Projektchef',
    'Project Name': 'Projektnamn',
    'Project Number': 'Projektnummer',
    'Project Organisation': 'Projektorganisation',
    'Project Overview': 'Projektöversikt',
    'Project Setup': 'Projektinställningar',
    'Project Start': 'Projektstart',
    'Project Type': 'Typ av entreprenad',
    'Project': 'Projekt',
    'Property Service': 'Förvaltare',
    'Purple': 'Lila',
    'QR code': 'QR-kod',
    'Quality Controller': 'Kvalitetsansvarig',
    'Quality Document': 'Kvalitetsdokument',
    'Red': 'Röd',
    'Registration link management': 'Hantera registreringslänkar',
    'Registration Number': 'Organisationsnummer',
    'Remove this after merging': 'Ta bort detta kort efter sammanslagning',
    'Remove': 'Ta bort',
    'Requires Lull': 'Kräver Lull',
    'Reset filters': 'Återställ filter',
    'Responsible Manager': 'DRI',
    'Responsible': 'Ansvarig',
    'Revert approval': 'Backa godkännande',
    'Review and sign': 'Granska och skriv under',
    'Review your entry': 'Granska ditt inlägg',
    'Risk Analysis': 'Riskanalys',
    'Roofing membrane': 'Taktäckning Papp',
    'Roofing Membrane': 'Taktäckning Papp',
    'Roofing Sedum': 'Taktäckning Sedum',
    'Roofing Sheet Metal': 'Taktäckning Plåt',
    'Roofing Tiles': 'Taktäckning Tegel',
    'Roofrail/Lift': 'Takskena/Lift',
    'Sat': 'Lör',
    'Saturday': 'Lördag',
    'Save': 'Spara',
    'Scaffolding': 'Ställning',
    'Screed': 'Flytspackel',
    'Seal/Jointing Fire': 'Fogning Brand',
    'Seal/Jointing': 'Fogning',
    'Search by name or number to add': 'Sök via namn eller nummer för att lägga till',
    'Search or Add New': 'Sök eller lägg till',
    'Section Title': 'Sektionstitel',
    'Select all': 'Välj alla',
    'Select none': 'Välj ingen',
    'Select all different': 'Välj alla olika',
    'Select Company': 'Välj företag',
    'Select delivery recipient (optional)': 'Godsmottagare (valfri)',
    'Select file': 'Välj fil',
    'Select master (Which contact card to save info to)': 'Välj master (Vilket kort info sparas på)',
    'Select option': 'Välj...',
    'Select project': 'Välj projekt',
    'Self-Inspection': 'Egenkontroll',
    'Send reminder': 'Skicka påminnelse',
    'Send a request for files to the person in charge.': 'Skicka begäran om filer till ansvarig.',
    'Send registration link to the person in charge.': 'Skicka anmälningslänk till ansvarig.',
    'Send': 'Skicka',
    'Send email': 'Skicka epost',
    'Send missing files notification': 'Skicka meddelande om saknade filer',
    'September': 'September',
    'Service Electricity': 'Servis El',
    'Service Heating': 'Servis Värme',
    'Service Sprinkler': 'Service Sprinkler',
    'Service Telecom': 'Servis Data',
    'Service VA': 'Servis VA',
    'Set a date...': 'Välj datum',
    'Set all empty to Sweden': 'Sätt allt tomt till Sverige',
    'Set Delivery fulfilled': 'Godkänn leverans',
    'Sheet Metal': 'Plåtslagare',
    'Sheet piling': 'Spont',
    'Sheet Piling': 'Spontning',
    'Show All Stages': 'Visa allas moment',
    'Show late deliveries': 'Visa leveranser',
    'Show late parts': 'Visa kontrollpunkt',
    'Show more': 'Visa mer',
    'Show My Stages': 'Visa mina moment',
    'Show Only Deliveries': 'Visa enbart leveranser',
    'Show Project': 'Visa Projekt',
    'Show Regardless Delivery': 'Visa oavsett leverans',
    'Show WPI': 'Visa API',
    'Site Assistant 2': 'Site Assistant 2',
    'Site Assistant 3': 'Site Assistant 3',
    'Site Assistant APD': 'Arbetsledare APD',
    'Site Assistant Deliveries': 'Arbetsledare Leveranser',
    'Site Assistant Documentation': 'Arbetsledare Dokumentation',
    'Site Assistant External': 'Arbetsledare Utvändigt',
    'Site Assistant Internal': 'Arbetsledare Invändigt',
    'Site Assistant': 'Arbetsledare',
    'Site Manager Apartments': 'Platschef Lägenheter',
    'Site Manager BMSS/LSS': 'Platschef BMSS/LSS',
    'Site Manager Hotel': 'Platschef Hotell',
    'Site Manager Office': 'Platschef Kontor',
    'Site Manager Pre-School': 'Platschef Förskola',
    'Site Manager': 'Platschef',
    'Solar Panels': 'Solceller',
    'Specify no. of boxes/pallets': 'antal lådor/pall',
    'Split': 'Dela upp etapp',
    'Sprinkler Design': 'Sprinkler Design',
    'Sprinkler Production': 'Sprinkler Produktion',
    'Sprinklers': 'Sprinkler',
    'Staircase railing': 'Trapphusräcke',
    'Start Date': 'Startdatum',
    'Status': 'Status',
    'Starts': 'Börjar',
    'Step': 'Steg',
    'Street Address': 'Gatuadress',
    'Sub contractor check': 'UE Avstämning',
    'Sub Title': 'Underrubrik',
    'Subcontractor (Assigned from project)': 'UE (Inställt på projektnivå)',
    'Subcontractor for {occupation} not assigned': 'Ansvarig ej utsedd för {occupation}',
    'Subcontractor not assigned': 'Ansvarig ej utsedd',
    'Subcontractor': 'UE',
    'Subcontractors': 'Underentreprenörer',
    'Success API': 'Registrering utförd',
    'Success redirect': 'Välkommen till vårt bygge',
    'Sun': 'Sön',
    'Sunday': 'Söndag',
    'Supply Controller External': 'Inköp Utvändigt',
    'Supply Controller Internal': 'Inköp Invändigt',
    'Supply Controller': 'Supply Controller',
    'Surveyor Foundation': 'Utsättare Grund',
    'Surveyor Frame': 'Utsättare Stomme',
    'Surveyor': 'Utsättare',
    'sv': 'Svenska',
    'Switch Template': 'Byt mall',
    'Syncing {count} documents': 'Synkroniserar {count} objekt',
    'System Benchmark': 'Samordnad Provning',
    'Terazzo': 'Terazzo',
    'The company lacks documents.': 'Företaget saknar dokument.',
    'The part is scheduled outside of the shown date range, and thus not shown in the projectplan': 'Etappen ligger utanför visat datumintervall och syns därför inte i projektplanen',
    'The person you selected has no email address. This person will not receive any notification emails. Are you sure you want to add this person to the list of Inspection participants?': 'Personen du valde har ingen e-postadress. Den här personen kommer inte att få några e-postmeddelanden. Är du säker på att du vill lägga till den här personen i listan över inspektionsdeltagare?',
    'The project is missing diary for some days, click date below to start:': 'Projektets dagbok är inte komplett ifylld, klicka på datum nedan för att fylla i',
    'The selected occupation {occupation} already exists': 'Rollen {occupation} finns redan på projektet',
    'There are currently no registration links, click to generate': 'Det finns inga registreringslänkar, klicka för att skapa',
    'There are unassigned parts': 'Det finns etapper utan ansvarig',
    'There is currently no registration link, click to generate': 'Det finns ingen länk, klicka för att skapa en',
    'These projects will be available to new persons registered': 'Dessa projekt skall nya personer få tillgång till vid registrering',
    'This action cannot be undone!': 'Denna åtgärd kan inte ångras!',
    'This diary entry is not yet signed!': 'Detta dagboksinlägg är ännu inte fullbordat',
    'This project is locked for editing by {username}. {lockedat}': 'Projektet är låst av {username}. {lockedat}',
    'This will remove the delivery fulfillment. Do you want to proceed?': 'Detta tar bort leveransbekräftelsen. Vill du fortsätta?',
    'Thu': 'Tor',
    'Thursday': 'Torsdag',
    'Tiling': 'Kakel / Klinkers',
    'Time': 'Tidpunkt',
    'Title': 'Titel',
    'to': 'för att',
    'Today': 'Idag',
    'Today\'s planned work will be downloaded automatically, unplanned work, please write under "{summary}"': 'Dagens planerade arbeten hämtas in automatiskt, oplanerade arbeten skriver du under ”{summary}”',
    'Todo Templates': 'To-Do Mallar',
    'Todo': 'To-Do',
    'Toggle Alerts': 'Växla Åtgärdsläge',
    'Toggle Dragging': 'Lås',
    'Total for project': 'Totalt för projektet',
    'Tue': 'Tis',
    'Tuesday': 'Tisdag',
    'Type': 'Typ',
    'UE-Link (connection to performer of moment in project settings)': 'UE-Link (Kopplingen till utförande för moment i projektinställningar)',
    'ueFile': 'UE-2021',
    'Undo': 'Ångra',
    'Unloading time': 'Lossningstid',
    'Unlock Dragging': 'Tillåt dra och släpp',
    'Unlock Project': 'Lås upp projektet',
    'Unknown': 'Okänd',
    'Updated Children Properties': 'Ändrade egenskaper på barn',
    'Updated Part Properties': 'Ändrade egenskaper på etapp',
    'Updated Project Properties': 'Ändrade egenskaper på projekt',
    'Updated Stage Properties': 'Ändrade egenskaper på moment',
    'Upload date': 'Uppladdningsdatum',
    'Upload': 'Ladda upp',
    'Used Before': 'Använd tidigare',
    'User': 'Användare',
    'Username': 'Användarnamn',
    'VAT Number': 'Momsregistreringsnummer',
    'Ventilation Design': 'Ventilation Design',
    'Ventilation FTX': 'Ventilation FTX',
    'Ventilation Inspection': 'OVK',
    'Ventilation': 'Ventilation',
    'Vibration analysis': 'Vibration & Buller-mätning',
    'View Project Log': 'Visa Projektlogg',
    'View Project Plan': 'Se Tidsplan',
    'View the previous entry': 'Visa föregående inlägg',
    'View Workplace Introductions': 'Visa APIer',
    'Visible projects': 'Synliga projekt',
    'VS Central': 'VS UC',
    'VS Design': 'VS Design',
    'VS Foundation': 'VS Grund',
    'VS Internal': 'VS Invändigt',
    'VS': 'VS',
    'w.{week}': 'v.{week}',
    'Waste': 'Avfall',
    'Waterproofing Yard': 'Tätskikt Gårdsplan',
    'Waterproofing': 'Tätskikt',
    'Who will leave?': 'Vem skall bort?',
    'Weather data missing': 'Väderdata sakn',
    'Wed': 'Ons',
    'Wednesday': 'Onsdag',
    'Week': 'Vecka',
    'Work Days': 'Arbetsdagar',
    'Work Environment Plan': 'Arbetsmiljöplan',
    'Work Hours': 'Arbetstimmar',
    'Worker not assigned, please fill in below and go through project settings and make sure all others is accurate.': 'Utförare ej ifyllt, fyll i enligt nedan samt gå igenom och fyll i så långt möjligt i projektinställningar',
    'Working on Solution': 'Pågår',
    'Workplace Introduction for {person}': 'Arbetsplatsintroduktion för {person}',
    'Workplace Introduction': 'Arbetsplatsintroduktion',
    'Workplace Introductions': 'Arbetsplatsintroduktioner',
    'Works on Site': 'Arbetar på plats',
    'Write diary': 'Skriv dagbok',
    'Yes': 'Ja',
    'Yesterday ::: {days} days ago': 'Igår ::: {days} dagar sedan',
    'You can\'t move items when using filter': 'Du kan inte flytta moment eller etapper när du har filter på',
    'Zipcode': 'Postnummer',
    "Don't Delete": 'Återställ lösenord',
    "Don't mail": 'Maila ej',

    // Not sorted
    'haveFirstAidTraining.label': 'Har HLR-Träning',
    'haveId06.label': 'Har ID06 Registrering',
    'haveHotWorksEducation.label': 'Har utbildning i heta arbeten',
    'haveChronicCondition.label': 'Har någon kronisk sjukdom',
    'workEnvironmentPlanReview.label': 'Arbetsmiljöplan gås igenom',
    'apdPlanReview.label': 'APD-Plan gås igenom',
    'disposalsReview.label': 'Avfallshantering/fraktioner gås igenom',
    'scheduleReview.label': 'Arbetstider gås igenom',
    'helmetRegulationAccepted.label': 'Böteslista UE gås igenom',
    'rulesAndProtectionReviewe.label': 'Ordnings- & Skyddsregler gås igenom',

    'company-info': 'Denna tagg gör företaget sökbart i<br/> projektinställningar och i organistaion',
    'search-instructions':
      `Du kan söka på:
      <h1>Flera sökord</h1>
      Om du skriver flera ord, tex <strong>golv</strong> och <strong>tak</strong> kommer alla moment och etapper visas som matchar NÅGOT av orden. Om du söker
      på ord inom citationstecken måste hela texten matcha, söker du tex på <strong>slipa golv</strong> får du alltså träffar där ordet <strong>slipa</strong>
      ELLER <strong>golv</strong> finns med. Söker du på <strong>"Slipa golv"</strong> får du enbart träffar där hela frasen <strong>slipa golv</strong> finns med.
      <h1>Etappnamn</h1>
      Till exampel <strong>golv</strong> för att hitta etapper som <strong>Golvläggning</strong> och <strong>Slipning golv</strong>.
      <h1>Momentnamn</h1>
      Om du får en sökträff på ett momentnamn kommer momentet och alla dess etapper att visas.
      <h1>Delar av text</h1>
      Om du söker på <strong>el</strong> kommer du få träffar på etapper som heter <strong>El lägenhet 1</strong>
      och <strong>Mellanstor</strong>, men söker du på <strong>"el"</strong> får du enbart träff på hela ord, dvs inte tex <strong>Mellanstor</strong>
      <h1>Person</h1>
      Skriv @ för att visa personer involverade i projektet och visa de etapper personen är ansvarig för.
      `,
    'Pile driving Project Director': 'Pålning Projektledare',
    'Pile driving Site Manager': 'Pålning Platschef',
    'Pile driving Site Assistant': 'Pålning Arbetsledare',
    'Surveyor Spare': 'Utsättare Alternativ',
    'Garage door': 'Garageport',
    'Missing diary!': 'Dagbok saknas!',
    'Missing files': 'Saknade filer',
    'The project diary is not complete, Click on the date below to fill out': 'Projektets dagbok är inte komplett ifylld, Klicka på datum nedan för att fylla i',
    'Next to kin': 'Närmast anhörig',
    'Phone next to kin': 'Telefon anhörig',
    'Have first aid training': 'Har HLR-Träning',
    'Have hot works education': 'Har utbildning i heta arbeten',
    'Date': 'Datum',
    'Action': 'Handling',
    'Highlight date': 'Flagga datum',

    // Not translated because seems like there is no direct translation
    'Status hängavtal': 'Status hängavtal',
    // Hängavtal list
    'Not needed': 'Behövs ej',
    'Not OK': 'Ej OK',
    'Sole proprietors': 'Enmansföretag',
    'Hängavtal Byggnads': 'Hängavtal Byggnads',
    'Hängavtal Plåt-och vent': 'Hängavtal Plåt-och vent',
    'Member of BF ( Byggföretagen )': 'Medlem i BF ( Byggföretagen )',
    'Member of Maskinentreprenörerna': 'Medlem i Maskinentreprenörerna',
    'Member of Plåt-och vent company': 'Medlem i Plåt-och ventföretagen',
    'Member of Måleri company': 'Medlem i Måleriföretagen',
    'Member of Teknik company': 'Medlem i Teknikföretagen',
    'Member of Installations company': 'Medlem i Installationsföretagen',
    'Member of Elektriker union': 'Medlem i Elektrikerförbundet',
    'Machine Agreement': 'Maskinentreprenadavtalet',
    'Building Agreement': 'Byggnadsavtalet',

    'Ground Project Director': 'Mark Projektledare',
    'Ground Site Manager': 'Mark Platschef',
    'Ground Site Assistant': 'Mark Arbetsledare',
    'Cleaning building': 'Städ Bodar',
    'Cleaning office': 'Städ Bygg',
    'Organisation Aftermarket': 'Organisation Eftermarknad',
    'Aftermarket': 'Eftermarknad',
    'UE2021, SKV4820, LOA2?': 'UE2021, SKV4820, LOA2 och Hängavtal?',
    'Read more about what you need to know before making contract': 'Läs mer här vad som gäller innan avtalsskrivning',
    'What regulations complies when hiring a contractor?': 'Vad gäller när du anlitar ett företag?',
    'What and if the company needs a collective agreement is regulated by the occupation, you will find info via the link below, there you will also find if we used them before and therefore approved, in that case jump to step 3.': '1. Om företaget måste ha hängavtal styrs av vad dom jobbar med, en lista på krav för resp. yrkeskategori ser du via länken nedan, där ser du även ifall vi använt dom sedan tidigare och dom är godkända, isåfall hoppa till steg 3.',
    '- Regulation list based on occupation': '- Lista yrkeskategori per företag',
    '2. If needed agreement, first search via their homepage below:': '2. Ifall dom kräver medlemsskap eller avtal med fackförening kan man först söka via deras hemsida nedan:',
    '- Search connected companies ”BF” here': '- Sök medlemsföretag BF här',
    '- Search connected companies ”ME” here': '- Sök medlemsföretag ME här',
    '3. If all above is approved make the contractor send in all according to the checklist, you will find this and all needed documents via link below:': '3. Ifall ovanstående punkter äruppfyllda behöver allt enligt checklista tas in från UE och skickas till HR-Avdelningen. Övriga frågor tas genom HR.',
    '- Checklist + Documentation': '- Checklista + Dokumentation',
    'todo-list-instructions':
      `
      <p>
        Listor är ett enkelt sätt att prioritera arbetet och kontrollera uförandet emot.
      </p>
      <p>
        Här kan du välja en förinställd lista, eller lägga till punkter med fritextfältet nedan.
      </p>
      `,
    'editInspectionTemplates.header': 'Inspektionsmallar',
    'editInspectionTemplates.line1': 'Här kan du skapa eller redigera inspektionsmallar.',
    'editInspectionTemplates.line2': 'Inspektionsmallar kan användas för att skapa inspektionsrundor, till exempel Skyddsronder, Slutbesiktning och dylikt.',
    'editInspectionSections.line1': 'Inspektionsmallar innehåller ett eller flera delmoment, som i sin tur innehåller ett antal kontrollpunkter',
    'editInspectionSections.line2': 'Exempelvis har en skyddsrond momenten Utvänding ordning, Avfallshantering, mflr.',
    'editInspectionSections.line3': 'Här skapar och redigerar du de olika momenten i en inspektionsrunda.',
    'comments-instructions': `Ge feedback, ställ en fråga, kommentera.<br>
      <i>( @ följt av namn notifierar person )</i>`,

    'confirm-yes': 'Ja, bekräfta',
    'confirm-cancel': 'Avbryt',
  };

  const translationsEn = {
    'fTaxCertificateFile': 'F-Tax',
    'companyRegistrationFile': 'Company registration',
    'insuranceContractEmployeesFile': 'Insurance contract employees',
    'ueFile': 'UE-2021',
    'businessInsuranceFile': 'Business insurance',
    // '': ''
    'fileStatus.NOT_LOADED': 'Missing',
    'fileStatus.FOR_APPROVAL': 'For Approval',
    'fileStatus.APPROVED': 'Approved',
    'fileStatus.WRONG': 'Wrong',
    'fileName.id06CardFile': 'ID06 File',
    // Legacy name for ID06 file
    'fileName.confirmationFile': 'ID06 File',
    'fileName.idFile': 'ID File',
    'fileName.ueFile': 'UE-2021 file',
    'fileName.safetyConstructionTrainingFile': 'Safety construction training file',
    'fileName.safeLiftingFile': 'Safe lifting file',
    'fileName.hotWorkFile': 'Hot work file',
    'fileName.cprTrainingFile': 'CPR training file',
    'fileName.workInMobileWorkPlatformsFile': 'Work in mobile work platforms file',
    'fileName.additionalFile': 'Additional file',
    'inspection-stage-title.INIT': 'Draft',
    'inspection-stage-title.PREPARE': 'Preparing',
    'inspection-stage-title.IN_PROGRESS': 'In progress',
    'inspection-stage-title.COMPLETE': 'In progress',
    'inspection-stage-title.FINALIZED': 'Round done',
    'inspection-stage-title.REPORTED': 'Report sent',
    'codeOfConduct': 'Code of Conduct',
    'codeOfConduct.CHECKED': 'Approved',
    'codeOfConduct.UNCHECKED': 'For approval',
    'codeOfConduct.UNKNOWN': 'Missing',
    'codeOfConduct.filter.CHECKED': 'Code of Conduct approved',
    'codeOfConduct.filter.UNCHECKED': 'Code of Conduct for approval',
    'codeOfConduct.filter.UNKNOWN': 'Code of Conduct missing',
    // '': ''
    'en': 'English',
    'sv': 'Svenska',
    'haveFirstAidTraining.label': 'Have first aid training',
    'haveId06.label': 'Have ID06 registration',
    'haveHotWorksEducation.label': 'Have hot works education',
    'haveChronicCondition.label': 'Have any chronic condition',
    'workEnvironmentPlanReview.label': 'Work plan is reviviewed',
    'apdPlanReview.label': 'APD Plan is reviviewed',
    'disposalsReview.label': 'Disposals/fractions reviviewed',
    'scheduleReview.label': 'Schedule is reviviewed',
    'helmetRegulationAccepted.label': 'Penaltylist UE is reviewed',
    'rulesAndProtectionReviewe.label': 'Rules of order & Protection reviewed',
    'Success API': 'Finished',
    'Success redirect': 'We\'ll redirect to the start now.',
    'company-info': 'This tag makes the company searchable in projectsettings and organisation',
    'editInspectionTemplates.header': 'Inspection templates',
    'editInspectionTemplates.line1': 'Here you can create and edit Inspection templates.',
    'editInspectionTemplates.line2': 'Inspection templates can be used to create inspection rounds, for example Safety rounds, Final inspection, etc.',
    'editInspectionSections.line1': 'Inspection templates contain one or more sections, which in turn contain a number of controlled points.',
    'editInspectionSections.line2': 'For example, a "Security" section could contain elements like "Turnout order", "Waste management", etc.',
    'editInspectionSections.line3': 'Here you can create and edit the various sections of an Inspection Round.',
    'search-instructions':
      `
      You can search on:
      <h1>Several words</h1>
      If you enter several words, e.g. <strong>floor</strong> and <strong>roof</strong>, all stages and parts will be shown that matches EITHER word.
      If you search on several words within quotes, the whole phrase must match. I.e if you search for <strong>floor</strong> and <strong>finnish</strong>,
      all stages and parts will be shown that matches EITHER word. If you search for <strong>"floor finnish"</strong> you will only get hits
      where the whole phrase matches.
      <h1>Part name</h1>
      For example <strong>floor</strong> to find parts like <strong>Ground floor</strong> and <strong>Floor preparations</strong>.
      <h1>Stage name</h1>
      If you get a match on a stage name, the stage and all it's children will be shown.
      <h1>Partial matches</h1>
      If you search for <strong>Low</strong>, you'll match parts like <strong>Low Current<strong> an <strong>Slow Elevator</strong>,
      but if you search for <strong>"low"</strong> you will only get matches on full words, ie <strong>Low Current<strong> but not <strong>Slow Elevator</strong>.
      <h1>Person</h1>
      Type @ to select persons to search by, and parts will be shown where the person is responsible
      `,
    'todo-list-instructions':
      `
      <p>
        Check lists are an easy way to prioritize and control you work
      </p>
      <p>
        You can chose to add items from predefined templates, or add your own items by the input field below.
      </p>
      `,
    'editInspectionTemplates':
      `
      <h1>Inspection templates</h1>
      <p>Create or edit inspection templates</p>
      <p>Inspection tamplates are used to create inspection rounds of different types</p>
      `,
    'comments-instructions':
      `Give feedback, ask a question, comment.<br>
      <i>( @ followed by name notifies person )</i>`,

    'confirm-yes': 'Yes',
    'confirm-cancel': 'Cancel',
  };

  Vue.i18n.add('sv', translationsSv);
  Vue.i18n.add('en', translationsEn);
  Vue.i18n.set('sv');
};



// WEBPACK FOOTER //
// ./src/i18n/index.js